<template>
  <div>
    <h2>Get CSV</h2>
    <div v-if="processButton">
      <div class="calendar-block">
        <el-date-picker
          v-model="periodSelected"
          type="datetimerange"
          range-separator="To"
          start-placeholder="Start date"
          end-placeholder="End date"
          :default-time="['00:00:00', '23:59:00']">
        </el-date-picker>
      </div>
      <el-button @click="processCsv" type="success">{{ $t('processCsv') }}</el-button>
    </div>
    <div v-else>
      <p>{{ $t('emailWillBeSent')}}</p>
      <p>{{ getUserMail }}</p>
    </div>
  </div>
</template>

<script>
import DateTimeManipulation from '../mixins/DateTimeManipulation';

export default {
  data() {
    return {
      processButton: true,
      dlButton: false,
      loadingBtn: false,
      percentage: 0,
      periodSelected: '',
      filename: '',
      polling: null,
      userMail: 'test@stone-edge.io',
    }
  },
  beforeDestroy () {
    this.periodSelected = '';
    clearInterval(this.polling);
  },
  computed: {
    csvFilename() {
      return this.$store.getters.getCsvFilename;
    },
    getUserMail() {
      return this.$store.getters.getUserMail;
    },
  },
  methods: {
    async processCsv() {
      this.processButton = false;
      let csvData =  {
        start : this.periodSelected[0] ? this.getEpochFromDate(this.periodSelected[0]) / 1000 : (this.getEpochFromNow()/1000) - (86400 * 30),
        end : this.periodSelected[1] ? this.getEpochFromDate(this.periodSelected[1]) / 1000 : this.getEpochFromNow() / 1000
      }
      if (csvData.start > csvData.end) {
        const time = [csvData.start, csvData.end];
        csvData.start = time[1];
        csvData.end = time[0];
      }
      this.$store.dispatch('getCSV', csvData);
    },
  },
  mixins: [DateTimeManipulation]
}
</script>

<style scoped>
  .calendar-block {
    display: flex;
    margin-bottom: 12px;
  }
</style>
